<form id="dynamicEditForm" [formGroup]="formGroup!" autocomplete="off">
  @for (row of visibleRows; track $index) {
    <div class="form-row row">
      @for (field of row; track field.key) {
        <div [class]="getColClass(field)">
          <label [for]="field.key" class="control-label" [class.required]="isRequired(field)">
            {{ field.labelKey | translate }}
          </label>

          @if (isTextInput(field)) {
            <input
              [id]="field.key"
              [name]="field.key"
              [type]="getInputType(field)"
              class="form-control"
              [readonly]="isReadonly(field)"
              [formControlName]="field.key" />
          }

          @if (field.control === 'textarea') {
            <textarea
              [id]="field.key"
              [name]="field.key"
              class="form-control"
              [readonly]="isReadonly(field)"
              [formControlName]="field.key"></textarea>
          }

          @if (field.control === 'date') {
            <ejs-datepicker
              [id]="field.key"
              class="dtpkr"
              format="dd.MM.yyyy"
              [formControlName]="field.key">
            </ejs-datepicker>
          }

          @if (field.control === 'enum-select') {
            @if (field.enumOptions) {
              <app-enum-drop-down-list
                [id]="field.key"
                width="100%"
                [enumType]="$safeNavigationMigration(field.enumOptions?.enumType)"
                [showClearButton]="isRequired(field) ? false : true"
                [baseTranslationString]="$safeNavigationMigration(field.enumOptions?.translationKeyPrefix)"
                [excludeEnumMembers]="$safeNavigationMigration(field.enumOptions?.excludeValues)"
                [formControlName]="field.key">
              </app-enum-drop-down-list>
            } @else {
              <ejs-dropdownlist
                [id]="field.key"
                [dataSource]="getDropDownDataSource(field)"
                [fields]="{ text: 'text', value: 'value' }"
                [showClearButton]="isRequired(field) ? false : true"
                [placeholder]="field.placeholderKey ? (field.placeholderKey | translate) : ''"
                [formControlName]="field.key">
              </ejs-dropdownlist>
            }
          }

          @if (field.control === 'reference-select') {
            <app-dynamic-autocomplete
              [id]="field.key"
              [getDataFunction]="getReferenceDataFunction(field)"
              [initialItem]="initialReferenceItems[field.key]"
              [placeholder]="field.placeholderKey ?? field.labelKey"
              [isFormComponent]="true"
              [formControlName]="field.key">
            </app-dynamic-autocomplete>
          }

          @if (field.control === 'checkbox') {
            <app-yes-no-group-button [id]="field.key" [formControlName]="field.key"></app-yes-no-group-button>
          }

          @if (field.control === 'custom' && customFieldTemplates[field.key]) {
            <ng-container *ngTemplateOutlet="customFieldTemplates[field.key]; context: { formGroup: formGroup, field: field }"></ng-container>
          }

          <app-error-messages [control]="getControl(field.key)!"></app-error-messages>
        </div>
      }
    </div>
  }
</form>
